import { useOrderPageContext } from '../OrderPageContext';
import { orderHasCosigners } from '../utils/orderHasCosigners';

/** Returns true if the order must be signed by someone other than its owner. */
export const useHasCosigners = (): boolean => {
  const { currentOrder } = useOrderPageContext();

  return (
    !!currentOrder &&
    orderHasCosigners(currentOrder.signatories, currentOrder.userId)
  );
};
